"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTextToSpeech = useTextToSpeech;
var _react = require("react");
// Ported verbatim from lobees-web's ConversationHelper.js speak/stopSpeaking.
function useTextToSpeech() {
  const speak = (0, _react.useCallback)(function (text) {
    let lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
    if (!window.speechSynthesis || !text) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang === "es" ? "es-ES" : "en-US";
    utterance.rate = 1;
    utterance.pitch = 1;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utterance);
  }, []);
  const stop = (0, _react.useCallback)(() => {
    var _window$speechSynthes;
    (_window$speechSynthes = window.speechSynthesis) === null || _window$speechSynthes === void 0 || _window$speechSynthes.cancel();
  }, []);
  return {
    speak,
    stop
  };
}